import React, { useEffect, useState } from "react";
import CookieConsent from "react-cookie-consent";
import { Helmet } from "react-helmet";
import { Toaster } from "react-hot-toast";
import { EA_MODAL_PAGES, PRODUCT_PAGES, PAID_ADS_LANDING_PAGES } from "../constants";
import Footer from "../partials/Footer";
import Header from "../partials/Header";
import { Link } from "gatsby";
import EaModal from "./EaModal";
import AutoInteractiveDemo from "./InteractiveDemo/AutoInteractiveDemo";
import { Script } from "gatsby";

export default function Layout({
  children,
  location,
  setIsMobileMenuOpen = null,
  hideFooter = false,
  hideHeader = false,
  mainClasses,
  theme = "default",
  isStickyCTA,
  loadLayoutWithScriptsOnly = false,
  dataMode = false,
  overflow,
  layoutClasses = "",
}) {
  const [scrollY, setScrollY] = useState(0);

  // Interactive demo popup logic - with defensive checks
  const path = location?.pathname || "";
  const isProductPage =
    typeof path === "string" &&
    Array.isArray(PRODUCT_PAGES) &&
    PRODUCT_PAGES.some((page) => path.includes(page));
  const isPaidAdsLandingPage =
    typeof path === "string" &&
    Array.isArray(PAID_ADS_LANDING_PAGES) &&
    PAID_ADS_LANDING_PAGES.some((page) => path.includes(page));
  const isBlogPage = typeof path === "string" && path.includes("/blog/");
  const isPricingPage = path === "/pricing";
  const shouldShowDemo =
    typeof window !== "undefined" &&
    (isProductPage || isPaidAdsLandingPage) &&
    !isPricingPage;

  // Check if this is the calculator page to fix sticky positioning
  const isCalculatorPage =
    typeof path === "string" && path.includes("/build-vs-buy-calculator");

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    window.dispatchEvent(new Event("storage"));
  };

  return (
    <>
      <Helmet htmlAttributes={{ lang: "en-GB" }}>
        {/* FevIcons Start */}
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />
        <link rel="icon" type="image/png" href="/favicon.svg" />
        {/* FevIcons End */}
        <link
          rel="preload"
          as="image"
          href="/heroKusamaVector.svg"
          type="image/svg+xml"
        />
        <link
          rel="preload"
          as="image"
          href="/dataAgentsLP.png"
          type="image/png"
        />

        <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
        <script>{`!function () {var reb2b = window.reb2b = window.reb2b || [];if (reb2b.invoked) return;reb2b.invoked = true;reb2b.methods = ["identify", "collect"];reb2b.factory = function (method) {return function () {var args = Array.prototype.slice.call(arguments);args.unshift(method);reb2b.push(args);return reb2b;};};for (var i = 0; i < reb2b.methods.length; i++) {var key = reb2b.methods[i];reb2b[key] = reb2b.factory(key);}reb2b.load = function (key) {var script = document.createElement("script");script.type = "text/javascript";script.async = true;script.src = "https://s3-us-west-2.amazonaws.com/b2bjsstore/b/" + key + "/reb2b.js.gz";var first = document.getElementsByTagName("script")[0];first.parentNode.insertBefore(script, first);};reb2b.SNIPPET_VERSION = "1.0.1";reb2b.load("GOYPYHVEWROX");}();`}</script>
        <script
          async
          defer
          src="https://static.cdn.prismic.io/prismic.js?new=true&repo=encord"
        />
        <script
          src="https://tag.clearbitscripts.com/v1/pk_3adfa5e57fcda43370d4da97618f3856/tags.js"
          referrerpolicy="strict-origin-when-cross-origin"
          defer
        ></script>
        <script defer src="https://app.revenuehero.io/scheduler.min.js" />

        {/* <script>
          {`!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
 },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
 a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
 twq('config','obxe0');`}
        </script> */}
      </Helmet>
      {!loadLayoutWithScriptsOnly ? (
        <div
          className={`flex flex-col min-h-screen ${!isCalculatorPage ? "overflow-hidden" : ""} ${layoutClasses}`}
        >
          {/*  Site header */}
          {!hideHeader && (
            <Header
              setIsMobileMenuOpen={setIsMobileMenuOpen}
              location={location}
              theme={
                theme === "transparent"
                  ? scrollY < 72
                    ? "transparent"
                    : "default"
                  : theme
              }
            />
          )}
          {/*  Page content */}
          <main
            className={`flex-grow ${overflow && "overflow-hidden"} ${
              dataMode ? "dark" : "light"
            } ${mainClasses}`}
          >
            <Toaster position="top-right" reverseOrder={false} />
            {children}
          </main>

          {/*  Site footer */}
          {!hideFooter && <Footer theme={theme} isStickyCTA={isStickyCTA} />}

          <section className="fixed bottom-0 w-full z-[999] flex flex-col">
            {isStickyCTA && (
              <section className="flex justify-center py-3 bg-white shadow-lg sm:hidden backdrop-blur">
                <Link
                  to={"/try-it-free/"}
                  className="btn w-80 text-white bg-[#4F33CA] shrink-0 rounded-full font-semibold border border-[#4F33CA]"
                >
                  Get started
                </Link>
              </section>
            )}
            {/* <CookieConsent
              location="bottom"
              buttonText="Accept"
              cookieName="myAwesomeCookieName2"
              contentClasses="!flex-none"
              style={{ background: "#2B373B", justifyContent: "start" }}
              buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
              buttonClasses="!mx-0 sm:mx-[15px]"
              expires={150}
              containerClasses={`flex-col sm:flex-row ${isStickyCTA && "sm:!fixed !relative"
                }`}
              onAccept={handleAccept}
            >
              This website uses cookies to enhance the user experience.{" "}
            </CookieConsent> */}
          </section>
          {EA_MODAL_PAGES.includes(location?.pathname) && (
            <EaModal location={location} />
          )}
        </div>
      ) : (
        children
      )}

      {/* Auto Interactive Demo Popup - Load on ALL pages when needed (including blog pages) */}
      {shouldShowDemo && <AutoInteractiveDemo />}
    </>
  );
}
